import styled from "styled-components";

export const HistoryDeviceMetricsWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 30px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    grid-auto-rows: minmax(300px, 1fr);

    padding-right: 6px;
    box-sizing: border-box;
`;

export const FilterBar = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    margin-bottom: 10px;
    & .query-button .ant-btn-disabled {
        background-color: #999999 !important;
        color: #EEEEEE;
    }

    & .query-button .ant-btn-disabled:hover {
        background-color: #999999 !important;
        color: #EEEEEE;
    }

    & .query-button {
        background-color: #0059ff;
    }
`;

export const FilterRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 5px;

    & .ant-select-selector {
        overflow: hidden;
    }

    & .ant-select-selection-overflow {
        flex-wrap: nowrap;
    }
`;

export const FilterItemLabel = styled.div`
    font-size: 12px;
    color: #333333;
    text-align: left;
    padding-left: 10px;
    margin-bottom: 5px;
    box-sizing: border-box;
    letter-spacing: 2px;
`;

export const SearchResult = styled.div`
    border-radius: 5px;
    flex: 1 1 auto;
`;

export const ChartsWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 30px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    grid-auto-rows: minmax(300px, 1fr);

    padding-right: 6px;
    box-sizing: border-box;

`;

export const ChartWrapper = styled.div`
    display: flex;
    flex-direction: column; 
    align-items: stretch;
`;

export const ChartHeader = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 8px;
`;

export const ChartName = styled.div`
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-right: 10px;
`;

export const ChartHeaderColorBlock = styled.div`
    width: 3px;
    height: 100%;
    height:20px;
`;

export const ChartInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
`;

export const ChartLatestMetricTime = styled.div`
    font-size: 11px;
    color: #555555;
`;

export const ChartUnit = styled.div`
    font-size: 13px;
    color: #555555;
`;

export const EChartsWrapper = styled.div`
    flex: 1 1 auto;
`;

